<template>
  <div class="my-4">
    <document-type-header
      :title="$t('iframe_page.doctypes.proof_address')"
      :statusLabel="statusLabel"
      :statusIcon="statusIcon"
      :subTitle="subTitle">
      {{ $t('iframe_page.docinfo.proof_address')}}
    </document-type-header>
    <br>
    <list-dropdown
      :placeholder="$t('iframe_page.doctypes.inform_justificatif')"
      :options="[$t('iframe_page.docinfo.bill'), $t('iframe_page.docinfo.rent_receipt'), $t('iframe_page.docinfo.sworn_statement')]"
      @input="changeListType"
      v-model="type">
    </list-dropdown>
    <br>


  <div v-if="type === $t('iframe_page.docinfo.sworn_statement')">
    <document-type-form
      multipleDocs
      docType= "Declaration"
      :idDocument="declareHostDocs"
      name="docTypeFormProof"
      :onValidate="validateButton"
      :subTitle="$t('iframe_page.docinfo.sworn_statement')"
      :title="$t('iframe_page.docinfo.sworn_statement')"
      v-model="declareDocs">
    </document-type-form>
    <hr>
    <document-type-form
      multipleDocs
      docType="IdCardHost"
      :idDocument="idHostDoc"
      :onValidate="validateButton"
      name="docTypeFormIdHost"
      :subTitle="$t('iframe_page.docinfo.id_host')"
      :title="$t('iframe_page.docinfo.id_host')"
      v-model="idHostDocs">
    </document-type-form>
    <hr>
    <document-type-form
      multipleDocs
      docType= "ProofAdress"
      :idDocument="proofAdressDoc"
      name="docTypeFormProofAdress"
      :subTitle="$t('iframe_page.docinfo.proof_address_host')"
      :title="$t('iframe_page.docinfo.proof_address_host')"
      v-model="proofHostDocs">
    </document-type-form>
</div>

 <div v-if="type === $t('iframe_page.docinfo.bill')">
   <document-type-form
     multipleDocs
     docType= "Bill"
     :idDocument="billDoc"
     name="docTypeFormBill"
     :subTitle="$t('iframe_page.docinfo.bill')"
     :title="$t('iframe_page.docinfo.bill')"
     v-model="billDocs">
   </document-type-form>
 </div>
  <div v-if="type === $t('iframe_page.docinfo.rent_receipt')">
    <document-type-form
      multipleDocs
      docType= "Receipe"
      :idDocument="receipeDoc"
      name="docTypeFormReceipe"
      :subTitle="$t('iframe_page.docinfo.rent_receipt')"
      :title="$t('iframe_page.docinfo.rent_receipt')"
      v-model="billDocs">
    </document-type-form>
  </div>
  </div>

</template>

<script>
import _ from 'lodash'

import DocumentTypeHeader from './DocumentTypeHeader.vue'
import DocumentTypeForm from './DocumentTypeForm.vue'
import listDropdown from '@/components/common/listDropdown.vue'

import docTypes from './data/docType.js'
import status from './data/status.js'

import '../LMSGstyle.css'

export default {
  name: 'DocumentProofAddress',
  components: {
    docTypes,
    'document-type-header': DocumentTypeHeader,
    'document-type-form': DocumentTypeForm,
    'list-dropdown': listDropdown
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    },
    value: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  mounted () {
    if (this.declareDocs && this.declareDocs.length ||
      this.proofHostDocs && this.proofHostDocs.length ||
      this.idHostDocs && this.idHostDocs.length) {
      this.type = this.$t('iframe_page.docinfo.sworn_statement')
    }
    if (this.billDocs && this.billDocs.length) {
      this.type = this.$t('iframe_page.docinfo.bill')
    }
    if (this.receipeDocs && this.receipeDocs.length) {
      this.type = this.$t('iframe_page.docinfo.rent_receipt')
    }
  },
  computed: {
    declareDocs: {
      get () {
        return this.value.declareDocs
      },
      set (val) {
        let tmp = _.cloneDeep(this.value)
        tmp = {
          declareDocs: val,
          proofHostDocs: tmp.proofHostDocs,
          idHostDocs: tmp.idHostDocs
        }
        this.$emit('input', tmp)
      }
    },
    billDocs: {
      get () {
        return this.value.billDocs
      },
      set (val) {
        let tmp = _.cloneDeep(this.value)
        tmp = {
          billDocs: val
        }
        this.$emit('input', tmp)
      }
    },
    receipeDocs: {
      get () {
        return this.value.receipeDocs
      },
      set (val) {
        let tmp = _.cloneDeep(this.value)
        tmp = {
          receipeDocs: val
        }
        this.$emit('input', tmp)
      }
    },
    idHostDocs: {
      get () {
        return this.value.idHostDocs
      },
      set (val) {
        let tmp = _.cloneDeep(this.value)
        tmp = {
          idHostDocs: val,
          proofHostDocs: tmp.proofHostDocs,
          declareDocs: tmp.declareDocs
        }
        this.$emit('input', tmp)
      }
    },
    proofHostDocs: {
      get () {
        return this.value.proofHostDocs
      },
      set (val) {
        let tmp = _.cloneDeep(this.value)
        tmp = {
          proofHostDocs: val,
          idHostDocs: tmp.idHostDocs,
          declareDocs: tmp.declareDocs
        }
        this.$emit('input', tmp)
      }
    },
    isWaiting () {
      return this.statusId === this.status.VERIFYING
    },
    declareDocsGlobalStatus () {
      this.checkStatus(this.declareDocs)
    },
    billDocsGlobalStatus () {
      this.checkStatus(this.billDocs)
    },
    idHostDocsGlobalStatus () {
      this.checkStatus(this.idHostDocs)
    },
    proofHostDocsGlobalStatus () {
      this.checkStatus(this.proofHostDocs)
    },
    receipeDocsGlobalStatus () {
      this.checkStatus(this.receipeDocs)
    },
    isDropDownActive () {
      return !!this.Dom7('.single-select-wrapper > div > ul')[0]
    }
  },
  data: function () {
    return {
      statusLabel: 'A compléter',
      statusIcon: '',
      declareHostDocs: '',
      idHostDoc: '',
      receipeDoc: '',
      billDoc: '',
      proofAdressDoc: '',
      fileList: [],
      isDocUploaded: false,
      uploadedFiles: [],
      selected: '',
      options: [],
      type: '',
      status: {
        TO_COMPLETE: [0],
        VERIFYING: [11, 13, 16, 30, 31],
        EXPIRED: [15],
        VALIDATED: [33],
        REFUSED: [12, 14, 32, 34]
      }
    }
  },
  methods: {
    changeListType (value) {
      this.type = value
      switch (this.type) {
        case this.$t('iframe_page.docinfo.sworn_statement'):
          this.proofHostDocs = []
          this.idHostDocs = []
          this.declareDocs = []
          break
        case this.$t('iframe_page.docinfo.bill'):
          this.billDocs = []
          break
        case this.$t('iframe_page.docinfo.rent_receipt'):
          this.receipeDocs = []
          break
      }
    },
    filesUploaded (files) {
      if (files.length) {
        this.isDocUploaded = true
      }
      this.$emit('input', files)
      this.fileList = files

      // afficher la suite
    },
    pickStatusProofAdress (statusToIdentify) {
      switch (statusToIdentify) {
        case status.TO_COMPLETE:
          this.statusId = status.TO_COMPLETE
          this.statusLabel = this.$t('iframe_page.status.to_complete')
          this.statusIcon = ''
          break
        case status.VERIFYING:
          this.statusId = status.VERIFYING
          this.statusLabel = this.$t('iframe_page.status.waiting')
          this.statusIcon = ''
          break
        case status.ACCEPTED:
          this.statusId = status.ACCEPTED
          this.statusLabel = ''
          this.statusIcon = 'success LMSGcolor'
          break
        case status.REFUSED:
          this.statusId = status.REFUSED
          this.statusLabel = this.$t('iframe_page.status.refused')
          this.statusIcon = 'icon fa-warning-o text-warning'
          break
      }
    },
    validateButton () {
      let that = this
      that.pickStatus(status.VERIFYING)
      that.$bus.$emit('mainNotif', { text: this.$t('iframe_page.valid_documents_1') + this.$t('iframe_page.valid_documents_2') })
      console.log('IIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIII')
    }
  }
}
</script>

<style>
.required {
  border-color: #ced4da !important;
}
</style>

<style scoped>
</style>
